import { render, staticRenderFns } from "./TTest.vue?vue&type=template&id=1fa7030c"
import script from "./TTest.vue?vue&type=script&lang=js"
export * from "./TTest.vue?vue&type=script&lang=js"
import style0 from "./TTest.vue?vue&type=style&index=0&id=1fa7030c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports